import type { NOTIF_BANNER_TYPE } from '@imprivata-cloud/components';

import FaceBioWarningImg from '../../../../assets/face-bio-orange.svg?react';
import FaceBioErrorImg from '../../../../assets/face-bio-red.svg?react';
import DefaultHexImage from '../../../../assets/face-user.svg?react';
import { HexContainer } from '../hex-container/hex-container';
import './enrollment-header.less';

interface EnrollmentHeaderProps {
  hexImage?: React.ReactNode;
  // Severity of the banner currently on screen. The banner itself is rendered by
  // the shared NotificationSystem; the enroll header only projects it onto the
  // central glyph — a red face for an error, orange for a warning.
  bannerStatus?: NOTIF_BANNER_TYPE;
}

export const EnrollmentHeader = ({
  hexImage = <DefaultHexImage />,
  bannerStatus,
}: EnrollmentHeaderProps) => {
  const renderImage = () => {
    switch (bannerStatus) {
      case 'error':
        return <FaceBioErrorImg />;
      case 'warning':
        return <FaceBioWarningImg />;
      default:
        return hexImage;
    }
  };
  return (
    <div className={`enrollment-header ${bannerStatus ?? ''}`}>
      <HexContainer className="authn-layout-header-hex" icon={renderImage()} />
    </div>
  );
};
